import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var JastBuildingVisitor = /*#__PURE__*/function () {
  function JastBuildingVisitor(tokens) {
    _classCallCheck(this, JastBuildingVisitor);
    this.tokens = tokens;
  }
  _createClass(JastBuildingVisitor, [{
    key: "visit",
    value: function visit(tree) {
      throw new Error('Unsupported operation visit(ParseTree)');
    }
  }, {
    key: "visitChildren",
    value: function visitChildren(node) {
      throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
  }, {
    key: "visitErrorNode",
    value: function visitErrorNode(node) {
      throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
  }, {
    key: "visitTerminal",
    value: function visitTerminal(node) {
      throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
  }]);
  return JastBuildingVisitor;
}();
export var getPositionFromToken = function getPositionFromToken(startToken, stopToken) {
  return [startToken.startIndex, (stopToken || startToken).stopIndex + 1];
};
export var getPositionFromContext = function getPositionFromContext(ctx) {
  return [ctx.start.startIndex, ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex];
};
export var getPositionsFromTerminalNodes = function getPositionsFromTerminalNodes(terminalNodes) {
  return terminalNodes.map(function (node) {
    return getPositionFromToken(node.payload);
  });
};
export var normalizeText = function normalizeText(text) {
  return text.toLowerCase().replace(/\s+/g, ' ');
};